import { FC } from "react";
import { Outlet } from "react-router-dom";
import { PlansProvider } from "../../providers/Financial/Plans/PlansProvider";
import { PricesProvider } from "../../providers/Financial/Plans/Prices/PricesProvider";
import AgentsCategories from "../../pages/Agents/AgentsCategories/AgentsCategories";
import { PlanAgentsCategoriesProvider } from "../../providers/Financial/Plans/PlanAgentsCategories/PlanAgentsCategoriesProvider";
import { CouponsProvider } from "../../providers/Financial/Coupons/CouponsProvider";
import { StatusProvider } from "../../providers/Financial/Coupons/Status/StatusProvider";
import { SubscriptionsProvider } from "../../providers/Financial/Subscriptions/SubscriptionsProvider";
import { PaymentsProvider } from "../../providers/Financial/Payments/PaymentsProvider";
import { RefundsProvider } from "../../providers/Financial/Refunds/RefundsProvider";

interface Props {
  element?: any;
  path?: string;
}

export const FinancialRoute: FC<Props> = () => {
  return (
    <PlansProvider>
      <PricesProvider>
        <PlanAgentsCategoriesProvider>
          <CouponsProvider>
            <StatusProvider>
              <SubscriptionsProvider>
                <PaymentsProvider>
                  <RefundsProvider>
                    <Outlet />
                  </RefundsProvider>
                </PaymentsProvider>
              </SubscriptionsProvider>
            </StatusProvider>
          </CouponsProvider>
        </PlanAgentsCategoriesProvider>
      </PricesProvider>
    </PlansProvider>
  );
};
